import EsusView from 'components/esus/EsusView'

export default function FichaProcedimentosView() {
  return <EsusView url='/pec/user/cds/procedimentos' />
}
